// lib/affiliate-rel.ts
// The one `rel` value for paid affiliate links. "sponsored" and "nofollow"
// tell search engines the link is paid; "noopener noreferrer" keep the opened
// tab from reaching back into ours (project rule, CLAUDE.md "Link Ethics").
export const AFFILIATE_REL = "sponsored nofollow noopener noreferrer";
